import AxiosConfig from '@/config/axios-config'

export const ArquivoAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/pdfs',
      {
        params: {
          page: pagina,
          url: filtro.url,
          titulo: filtro.titulo,
          criado_em_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
          criado_em_fim: filtro.createdDate ? filtro.createdDateRange.endDate : ''
        }
      }).then(response => response.data)
  },

  listarTodos () {
    return AxiosConfig.jalekoAPI().get('/admin/pdfs/todos').then(response => response.data)
  },

  listarTipos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/imagens/tipo').then(response => response.data.tipos_imagens)
  },

  editar (pdf) {
    let formData = new FormData()
    for (var key in pdf) {
      pdf[key] &&
      formData.append(key, pdf[key])
    }
    return AxiosConfig.secureJalekoAPI().put(`/admin/pdfs/${pdf.id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  salvar (pdfs, metadados) {
    let formData = new FormData()
    pdfs.map(pdf => {
      formData.append('pdfUpload[]', pdf)
      formData.append('titulo', metadados.titulo)
    })
    return AxiosConfig.secureJalekoAPI().post(`/admin/pdfs`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  deletar (id) {
    return AxiosConfig.jalekoAPI().delete('/admin/pdfs/' + id
    ).then(response => response.data)
  }

}

export default ArquivoAPI
